// Lightweight product-engagement beacons. Fire-and-forget: telemetry must
// never block or break navigation, so every failure is swallowed.
const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

type ActivityKind = "page_view" | "assurance_view" | "report_generated" | "scan_started";

// De-dupe rapid repeats (e.g. re-renders of the same view) within a session.
let lastEvent = "";
let lastAt = 0;

export function logActivity(kind: ActivityKind, detail: Record<string, unknown> = {}): void {
  try {
    const key = `${kind}:${JSON.stringify(detail)}`;
    const now = Date.now();
    if (key === lastEvent && now - lastAt < 15000) return;
    lastEvent = key;
    lastAt = now;
    void fetch(`${API_BASE}/v1/activity`, {
      method: "POST",
      credentials: "include",
      keepalive: true,
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ kind, detail }),
    }).catch(() => undefined);
  } catch {
    // never let telemetry surface an error
  }
}
